<template>
  <div>
    <changes-log :logs="projectLogs"></changes-log>
  </div>
</template>
<script>
import axios from 'axios'
import ChangesLog from '../../../../../../Helpers/Tabs/ChangesLogs.vue'

export default {
  data () {
    return {
      projectLogs: []
    }
  },
  components: {
    changesLog: ChangesLog
  },
  mounted () {
    this.loadProjectHistory()
  },
  methods: {
    async loadProjectHistory () {
      try {
        let r = await axios.get(`/v2/messages?type=action&targets[type]=projects&targets[id]=${this.$route.params.id}`)
        this.projectLogs = r.data
      } catch (error) {
        this.$toastr.error('Failed to load project history', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Projects/Single/Content/Tabs/LastActivity.vue